var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Bitecs, Component, BitecsSchema, type, defaultValue } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let LocomotionSchema = class extends BitecsSchema {
  constructor() {
    super(...arguments);
    __publicField(this, "_velocityX");
    __publicField(this, "_velocityY");
    __publicField(this, "_speed");
    __publicField(this, "_directionX");
    __publicField(this, "_directionY");
    __publicField(this, "_decayingVelocityX");
    __publicField(this, "_decayingVelocityY");
    __publicField(this, "_decayingVelocityTime");
    __publicField(this, "_decayingVelocityScale");
    __publicField(this, "_fixedDirection");
  }
  static get velocity() {
    return { x: this.velocityX, y: this.velocityY };
  }
  get velocity() {
    return LocomotionSchema.velocity;
  }
  static get velocityX() {
    return LocomotionSchema.store.velocityX[this.id];
  }
  get velocityX() {
    return LocomotionSchema.velocityX;
  }
  static set velocityX(value) {
    LocomotionSchema.store.velocityX[this.id] = value;
    LocomotionSchema.store.__changes[this.id] |= 1;
  }
  set velocityX(value) {
    LocomotionSchema.velocityX = value;
  }
  static get velocityY() {
    return LocomotionSchema.store.velocityY[this.id];
  }
  get velocityY() {
    return LocomotionSchema.velocityY;
  }
  static set velocityY(value) {
    LocomotionSchema.store.velocityY[this.id] = value;
    LocomotionSchema.store.__changes[this.id] |= 2;
  }
  set velocityY(value) {
    LocomotionSchema.velocityY = value;
  }
  static get speed() {
    return LocomotionSchema.store.speed[this.id];
  }
  get speed() {
    return LocomotionSchema.speed;
  }
  static set speed(value) {
    LocomotionSchema.store.speed[this.id] = value;
    LocomotionSchema.store.__changes[this.id] |= 4;
  }
  set speed(value) {
    LocomotionSchema.speed = value;
  }
  static get directionX() {
    return LocomotionSchema.store.directionX[this.id];
  }
  get directionX() {
    return LocomotionSchema.directionX;
  }
  static set directionX(value) {
    LocomotionSchema.store.directionX[this.id] = value;
    LocomotionSchema.store.__changes[this.id] |= 8;
  }
  set directionX(value) {
    LocomotionSchema.directionX = value;
  }
  static get directionY() {
    return LocomotionSchema.store.directionY[this.id];
  }
  get directionY() {
    return LocomotionSchema.directionY;
  }
  static set directionY(value) {
    LocomotionSchema.store.directionY[this.id] = value;
    LocomotionSchema.store.__changes[this.id] |= 16;
  }
  set directionY(value) {
    LocomotionSchema.directionY = value;
  }
  static get decayingVelocityX() {
    return LocomotionSchema.store.decayingVelocityX[this.id];
  }
  get decayingVelocityX() {
    return LocomotionSchema.decayingVelocityX;
  }
  static set decayingVelocityX(value) {
    LocomotionSchema.store.decayingVelocityX[this.id] = value;
    LocomotionSchema.store.__changes[this.id] |= 32;
  }
  set decayingVelocityX(value) {
    LocomotionSchema.decayingVelocityX = value;
  }
  static get decayingVelocityY() {
    return LocomotionSchema.store.decayingVelocityY[this.id];
  }
  get decayingVelocityY() {
    return LocomotionSchema.decayingVelocityY;
  }
  static set decayingVelocityY(value) {
    LocomotionSchema.store.decayingVelocityY[this.id] = value;
    LocomotionSchema.store.__changes[this.id] |= 64;
  }
  set decayingVelocityY(value) {
    LocomotionSchema.decayingVelocityY = value;
  }
  static get decayingVelocityTime() {
    return LocomotionSchema.store.decayingVelocityTime[this.id];
  }
  get decayingVelocityTime() {
    return LocomotionSchema.decayingVelocityTime;
  }
  static set decayingVelocityTime(value) {
    LocomotionSchema.store.decayingVelocityTime[this.id] = value;
    LocomotionSchema.store.__changes[this.id] |= 128;
  }
  set decayingVelocityTime(value) {
    LocomotionSchema.decayingVelocityTime = value;
  }
  static get decayingVelocityScale() {
    return LocomotionSchema.store.decayingVelocityScale[this.id];
  }
  get decayingVelocityScale() {
    return LocomotionSchema.decayingVelocityScale;
  }
  static set decayingVelocityScale(value) {
    LocomotionSchema.store.decayingVelocityScale[this.id] = value;
    LocomotionSchema.store.__changes[this.id] |= 256;
  }
  set decayingVelocityScale(value) {
    LocomotionSchema.decayingVelocityScale = value;
  }
  static get fixedDirection() {
    return LocomotionSchema.store.fixedDirection[this.id] === 1;
  }
  get fixedDirection() {
    return LocomotionSchema.fixedDirection;
  }
  static set fixedDirection(value) {
    LocomotionSchema.store.fixedDirection[this.id] = value ? 1 : 0;
    LocomotionSchema.store.__changes[this.id] |= 512;
  }
  set fixedDirection(value) {
    LocomotionSchema.fixedDirection = value;
  }
};
__decorateClass([
  type("float32"),
  defaultValue(0)
], LocomotionSchema.prototype, "_velocityX", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], LocomotionSchema.prototype, "_velocityY", 2);
__decorateClass([
  type("float32"),
  defaultValue(6)
], LocomotionSchema.prototype, "_speed", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], LocomotionSchema.prototype, "_directionX", 2);
__decorateClass([
  type("float32"),
  defaultValue(1)
], LocomotionSchema.prototype, "_directionY", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], LocomotionSchema.prototype, "_decayingVelocityX", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], LocomotionSchema.prototype, "_decayingVelocityY", 2);
__decorateClass([
  type("float32"),
  defaultValue(0)
], LocomotionSchema.prototype, "_decayingVelocityTime", 2);
__decorateClass([
  type("float32"),
  defaultValue(1)
], LocomotionSchema.prototype, "_decayingVelocityScale", 2);
__decorateClass([
  type("uint8"),
  defaultValue(0)
], LocomotionSchema.prototype, "_fixedDirection", 2);
LocomotionSchema = __decorateClass([
  Bitecs(),
  Component("Locomotion")
], LocomotionSchema);
const __vite_glob_0_13 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get LocomotionSchema() {
    return LocomotionSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  LocomotionSchema as L,
  __vite_glob_0_13 as _
};
//# sourceMappingURL=Locomotion-379972de.js.map
